/* */
// import { useCallback, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import actions from 'redux/actions';

// export default ({ isTrigger = true } = {}) => {
//   const { getVoluumSetting } = actions;
//   const dispatch = useDispatch();
//   const authReducer = useSelector((state) => state.authReducer);

//   useEffect(() => {
//     if (authReducer.isLogin && isTrigger) {
//       dispatch(getVoluumSetting());
//     }
//   }, [dispatch, authReducer.isLogin, isTrigger]);

//   const refetchVoluum = useCallback(() => {
//     dispatch(getVoluumSetting());
//   }, [dispatch]);

//   return {
//     refetchVoluum,
//   };
// };

import { showError } from 'helpers/handleError';
import { isObject } from 'lodash';
import { useEffect, useState, useCallback } from 'react';
import { useSave } from 'redux/store/StoreCached';
import VoluumService from 'services/VoluumService';

//* 1. Change service to call API
//* 2. Check function "checkConditionPass" to parse response
const useGetVoluum = ({ isTrigger = true, cachedKey = '' } = {}) => {
  const save = useSave();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  //! Function
  const checkConditionPass = useCallback((response) => {
    //* Check condition of response here to set data
    if (isObject(response?.data)) {
      setData(response?.data);
    }
  }, []);

  const fetch = useCallback(() => {
    if (!isTrigger) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const response = await VoluumService.getVoluumData();
        resolve(response);
      } catch (error) {
        showError(error);
        setError(error);
        reject(error);
      }
    });
  }, [isTrigger]);

  //* Refetch implicity (without changing loading state)
  const refetch = useCallback(async () => {
    const response = await fetch();
    checkConditionPass(response);
  }, [fetch, checkConditionPass]);

  //* Refetch with changing loading state
  const refetchWithLoading = useCallback(
    async (shouldSetData) => {
      try {
        setLoading(true);
        const response = await fetch();
        if (shouldSetData) {
          checkConditionPass(response);
        }
        setLoading(false);
      } catch (error) {
        showError(error);
        setLoading(false);
      }
    },
    [fetch, checkConditionPass]
  );

  useEffect(() => {
    if (cachedKey) {
      save(cachedKey, { data, loading, refetch });
    }
  }, [data, loading, refetch, cachedKey, save]);

  useEffect(() => {
    //* Clean old process if the new process runned
    let shouldSetData = true;
    refetchWithLoading(shouldSetData);

    return () => {
      shouldSetData = false;
    };
  }, [refetchWithLoading]);

  return { data, loading, error, refetch, refetchWithLoading };
};

export default useGetVoluum;
